import React, { Component, useState } from "react";
import $ from "jquery";
import { Redirect } from "react-router-dom";
import { Link } from "react-router-dom";
import Httpconfig from "../helpers/HttpconfigRetailer";
import Constant from "../../constants";
import { FormattedMessage, IntlProvider } from "react-intl";
import { I18nPropvider, LOCALES } from "../../i18nProvider";
import translate from "../../i18nProvider/translate";
import RetailerCss from "../../public/css/retailer/retailer_style.css";

export default class RetailerSideMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPromotionsSubmenu: false,
      Retailerprofile: "",
      RetailerDashboard: "",
      Retailerstock: "",
      RetailertransactionHistory: "",
      RetailerSettings: "",
      RetailerViewwallertReport: "",
      Coupons: "",
      Offers: "",
      Banners: "",
      Categories:""
    };
  }
  //Redirect to retailer profile page
  viewRetailerprofile = () => {
    window.location.href = "./Retailerprofile";
  };
  //Redirect to retailer Dashboard page
  viewRetailerDashboard = () => {
    window.location.href = "./Retailerdashboard";
  };
  //Redirect to retailer stock page
  viewStock = () => {
    window.location.href = "./Retailerstock";
  };
  //Redirect to retailer transaction history page
  viewtransactionHistory = () => {
    window.location.href = "./RetailertransactionHistory";
  };
  //Redirect to retailer settings
  viewsettings = () => {
    window.location.href = "./Retailersettings";
  };
  //Redirect to retailer wallert reports
  viewRetailerViewwallertReport = () => {
    window.location.href = "./ViewRetailercoupons";
  };
  componentDidMount = () => {
    let url_path = window.location.pathname;
    let pages = url_path.split("/");
    var page = pages[2];
    var obj = {};
    obj[page] = "active";
    this.setState({
      page: page,
    });
    //checking page rendered
    
    if (page == "Retailerprofile") {
      this.state.Retailerprofile = "active";
    }
    if (page == "Retailerdashboard" || page == "retailerpendingorders") {
      this.state.RetailerDashboard = "active";
    }
    if (page == "Retailerstock") {
      this.state.Retailerstock = "active";
    }
    if (page == "RetailertransactionHistory") {
      this.state.RetailertransactionHistory = "active";
    }
    if (page == "Retailersettings") {
      this.state.RetailerSettings = "active";
    }
    if (
      page === "RetailerViewwallertReport" ||
      page === "Coupons" ||
      page === "Offers" ||
      page === "Banners" ||
      page === "ViewRetailercoupons" ||
      page === "Retailercoupons" ||
      page === "ViewRetaileroffers"  ||
      page === "ViewRetailerCategories" ||
      page === "RetailerCategories" ||
      page === "RetailerOffers" ||
      page === "ViewRetailerBanners" ||
      page === "RetailerBanners"
         
      
      
    ) {
      this.setState({
        RetailerViewwallertReport: "active",
        showPromotionsSubmenu: true
      });
      if (page === "ViewRetailercoupons") this.setState({ Coupons: "active" });
      if (page === "Offers") this.setState({ Offers: "active" });
      if (page === "ViewRetaileroffers") this.setState({ Offers: "active" });
      if (page === "RetailerOffers") this.setState({ Offers: "active" });
      if (page === "Banners") this.setState({ Banners: "active" });
      if (page === "ViewRetailerBanners") this.setState({ Banners: "active" });
      if (page === "RetailerBanners") this.setState({ Banners: "active" });
      
      
      if (page === "Retailercoupons") this.setState({ Coupons: "active" });
      if (page === "ViewRetailerCategories") this.setState({ Categories: "active" });
      if (page === "RetailerCategories") this.setState({ Categories: "active" });
      
      
      
      
      
    }

    this.forceUpdate();
  };
  togglePromotionsSubmenu = () => {
    this.setState(prevState => ({
      showPromotionsSubmenu: !prevState.showPromotionsSubmenu
    }));
  };
  render() {
    return (
      <div class="container-fluid">
        <div class="row">
          <nav id="side_Nav" class="col-lg-2 col-md-2">
            <ul>
              <li
                class={
                  this.state.RetailerDashboard != ""
                    ? this.state.RetailerDashboard
                    : ""
                }
              // onClick={this.viewRetailerDashboard}
              >
                <Link to="/retailer/Retailerdashboard">
                  <img src="../images/retailer/manageOrder.svg" />
                  <p>Manage Order</p>
                </Link>
              </li>
              <li
                class={
                  this.state.Retailerstock != "" ? this.state.Retailerstock : ""
                }
              // onClick={this.viewStock}
              >
                <Link to="/retailer/Retailerstock">
                  <img src="../images/retailer/manageStock.svg" />
                  <p>Manage Stock</p>
                </Link>
              </li>

              {/* <li
                class={
                  this.state.RetailerViewwallertReport != ""
                    ? this.state.RetailerViewwallertReport
                    : ""
                }
                onClick={this.viewRetailerViewwallertReport}
              >
                <img src="../images/retailer/manageOrder.svg" />
                <p>Promitions</p>
              </li> */}
              <li class={`${this.state.RetailerViewwallertReport} ${this.state.showPromotionsSubmenu ? 'open' : ''}`}>
                <div onClick={this.togglePromotionsSubmenu}>
                  <img src="../images/retailer/manageOrder.svg" />
                  <p>Promotions</p>
                  <span className="submenu-toggle-icon">
                    {this.state.showPromotionsSubmenu ? '▼' : '▶'}
                  </span>
                </div>
                {this.state.showPromotionsSubmenu && (
                  <ul>
                    <li
                      class={this.state.Banners}
                    // onClick={() => window.location.href = "./Banners"}
                    >
                      <Link to="/retailer/ViewRetailerBanners">
                        <img src="../images/retailer/banner.svg" style={{ width: '0px', marginRight: '5px' }} />
                        <p>Banners</p>
                      </Link>
                    </li>
                    <li
                      class={this.state.Coupons}
                    // onClick={() => window.location.href = "./ViewRetailercoupons"}
                    >
                      <Link to="/retailer/ViewRetailercoupons">
                        <img src="../images/retailer/coupon.svg" style={{ width: '0px', marginRight: '5px' }} />
                        <p>Coupons</p>
                      </Link>
                    </li>
                    <li
                      class={this.state.Offers}
                    >
                     
                      <Link to="/retailer/ViewRetaileroffers">
                        <img src="../images/retailer/offer.svg" style={{ width: '0px', marginRight: '5px' }} />
                        <p>Offers</p>
                      </Link>
                    </li>

                    <li
                      class={this.state.Categories}
                    >
                      <Link to="/retailer/ViewRetailerCategories">
                        <img src="../images/retailer/offer.svg" style={{ width: '0px', marginRight: '5px' }} />
                        <p>Categories</p>
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
              <li
                class={
                  this.state.RetailertransactionHistory != ""
                    ? this.state.RetailertransactionHistory
                    : ""
                }
              // onClick={this.viewtransactionHistory}
              >
                <Link to="/retailer/RetailertransactionHistory">
                  <img src="../images/retailer/transactions.svg" />
                  <p>Transactions</p>
                </Link>
              </li>
              <li
                class={
                  this.state.RetailerSettings != ""
                    ? this.state.RetailerSettings
                    : ""
                }
              // onClick={this.viewsettings}
              >
                <Link to="/retailer/Retailersettings">
                  <img src="../images/retailer/settings.svg" />
                  <p>Settings</p>
                </Link>
              </li>

              <li
  class=""
>
  <Link to="/retailer/MobileLayout">
    <img src="../images/retailer/mobile.svg" />
    <p>Mobile Layout</p>
  </Link>
</li>
            </ul>
          </nav>
        </div>
      </div>
    );
  }
}
